<template>
    <!--面包屑 - 开始-->
    <div class="breadcrumbs">
        <a href="/">首页</a>
        <i>> </i>
        <span>{{work.gzleixing}}</span>
        <i> — </i>
        <span>{{work.gzleibie}}</span>
        <i> — </i>
        <span>{{work.gzxiangmu}}</span>
    </div>
</template>

<script>
    export default {
        name: "Mianbao",
        props: ["work"],
    }
</script>

<style>
    .breadcrumbs {
        height: 45px;
        line-height: 55px;
    }

    .breadcrumbs a {
        margin: 0 5px;
    }

    .breadcrumbs a:hover {
        color: #299be4
    }

    .breadcrumbs span,
    .breadcrumbs i {
        color: #666;
    }

    .breadcrumbs i {
        font-family: Verdana, Geneva, sans-serif
    }
</style>